<template>
    <div>
        <template v-for="field in fields">
            <h4 v-if="field.name == 'Heading' && !pdfView">{{ field.label }}</h4>

            <p v-if="field.name == 'Paragraph' && !pdfView" :class="(field.color ? 'alert alert-'+field.color : null)">{{ field.text }}</p>

            <div v-if="(field.name != 'Paragraph' && field.name != 'Heading') && (field.parent_field_id == null || (field.parent_field_id != null && field.value))" class="row mb-sm-2 mb-3">
                <label :class="`${labelSize}`" class="mb-0">{{ field.label }}:</label>
                <div :class="`${fieldSize}`">
                    <template v-if="field.name == 'Textarea'">
                        <div v-html="field.value"></div>
                    </template>
                    <template v-else-if="Array.isArray(field.value)" v-for="(val, key) in field.value">
                        <span v-if="key > 0">, </span>{{ val }}
                    </template>
                    <template v-else>{{ field.value }}</template>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        props: {
            fields: {
                type: Array,
                required: true,
            },

            labelSize: {
                type: String,
                default: 'col text-muted'
            },

            fieldSize: {
                type: String,
                default: 'col-md-10',
            },

            pdfView: {
                type: Boolean,
                default: false,
            }
        },

        data: function() {
            return {

            }
        },


        methods: {

        },

        mounted() {

        }
    }
</script>